import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import EstateJurisdictionLang from '@/modules/predefined/services/EstateJurisdictionLang';
import { capitalize } from '@/modules/core/app/helpers/StringHelper';

export class WillAdditionalNeedType extends Enum {
  key!: string;
  value!: string;
  description!: string;

  static HOTCHPOT_CLAUSE: WillAdditionalNeedType = {
    key: 'hotchpot_clause',
    get value(): string {
      return Lang.t('will.hotchpot-clause');
    },
    get description(): string {
      return Lang.t('will.equalize-given-to');
    }
  };

  static PET_GUARDIANSHIP: WillAdditionalNeedType = {
    key: 'pet_guardianship',
    get value(): string {
      return capitalize(
        Lang.t('will.pet-guardianship', {
          guardianship: EstateJurisdictionLang.guardianshipLabel
        }),
        true
      );
    },
    get description(): string {
      return Lang.t('will.set-guardian-pet', {
        guardian: EstateJurisdictionLang.guardianLabel
      });
    }
  };

  static SPENDRIFT_TRUST: WillAdditionalNeedType = {
    key: 'spendrift_trust',
    get value(): string {
      return Lang.t('will.spendrift-trust');
    },
    get description(): string {
      return Lang.t('will.limit-limit-spending');
    }
  };

  static STAGED_DISTRIBUTION_FOR_MINOR_BENEFICIARIES: WillAdditionalNeedType = {
    key: 'staged_distribution_for_minor_beneficiaries',
    get value(): string {
      return Lang.t('will.staged-distribution-beneficiaries');
    },
    get description(): string {
      return Lang.t('will.inheritance-given-in');
    }
  };

  static THIRD_LEVEL_DISTRIBUTION_AND_CLAUSE_CATASTROPHE: WillAdditionalNeedType = {
    key: 'third_level_distribution_and_clause_catastrophe',
    get value(): string {
      return Lang.t('will.third-and-catastrophe');
    },
    get description(): string {
      return Lang.t('will.add-alternate-the');
    }
  };

  static WILL_FOR_CORPORATION: WillAdditionalNeedType = {
    key: 'will_for_corporation',
    get value(): string {
      return Lang.t('will.will-for-corporation');
    },
    get description(): string {
      return Lang.t('will.if-you-own');
    }
  };

  static OTHER: WillAdditionalNeedType = {
    key: 'other',
    get value(): string {
      return Lang.t('will.other');
    },
    get description(): string {
      return Lang.t('will.you-be-specify');
    }
  };
}
